function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import React from 'react';

var _ref =
/*#__PURE__*/
React.createElement("path", {
  fill: "currentColor",
  d: "M26.6 73.6C23.1 72.4 19 71 19 67V49.2c0-4.1 2.6-6.8 4.9-9.1.7-.7 1.4-1.4 1.9-2.1 1-1 1.9-2.2 2.7-3.6 5.8-10.4 3.4-28.5 0-34-.1-.2-.4-.4-.8-.4H4.3c-.3 0-.6.2-.8.5-3.4 5.5-5.8 23.6 0 34 .8 1.4 1.7 2.6 2.7 3.6.6.7 1.2 1.4 1.9 2.1 2.3 2.3 4.9 5 4.9 9.1V67c0 4-4 5.4-7.6 6.6-2.8.9-5.4 1.8-5.4 4C0 81 5.4 81 16 81c10.7 0 16 0 16-3.4 0-2.2-2.6-3.1-5.4-4zM12.1 41.5c1.2.3 2.6.5 4 .5s2.7-.2 4-.5c-.8 1-1.5 2.1-2.1 3.4-1.2.2-2.5.2-3.8 0-.6-1.3-1.3-2.4-2.1-3.4zM4.9 2h22.2c3 5.5 4.9 22.2-.3 31.5-.6 1.1-3.2 6.5-10.8 6.5S5.9 34.6 5.3 33.5C.1 24.2 1.9 7.5 4.9 2zM16 79c-6.6 0-14 0-14-1.4 0-.8 2.1-1.5 4-2.1 3.8-1.3 9-3 9-8.5V49.2c0-.8-.1-1.6-.2-2.3.4 0 .8.1 1.2.1.4 0 .8 0 1.2-.1-.1.7-.2 1.5-.2 2.3V67c0 5.5 5.2 7.2 9 8.5 1.9.6 4 1.3 4 2.1C30 79 22.6 79 16 79z"
});

var _ref2 =
/*#__PURE__*/
React.createElement("path", {
  fill: "currentColor",
  stroke: "currentColor",
  strokeMiterlimit: 10,
  d: "M2 21h28l-.7 10.5-5.8 8-3.5 1-4 1L8.9 39l-5.4-6.3-2.2-9.5z"
});

var SvgComponent = function SvgComponent(props) {
  return React.createElement("svg", _extends({
    viewBox: "0 0 32 81"
  }, props), _ref, _ref2);
};

export default __webpack_public_path__ + "static/media/fort-wine-large.svg";
export { SvgComponent as ReactComponent };